/**
 * Feature flags — set to true to re-enable a feature across the entire app.
 * All UI references check FEATURES before rendering.
 */
export const FEATURES = {
  TIME_TRACKING: false,
  AI_ASSISTANT: false,
} as const;
